import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { formatDate } from '../utils/format-date'

const Outer = styled.div`
  display: flex;
  gap: 1rem;
  min-width: 0;
  @media (max-width: 60rem){
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
`

const Initial = styled.div`
  font-size: 3rem;
  font-weight: 700;
  flex: 0 0 2rem;
  display: flex;
  justify-content: center;
  min-width: 0;
  @media (max-width: 60rem){
    flex: 0 0 auto;
    font-size: 2rem;
  }
`

const DetailContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

const ItemDate = styled.div`
  font-size: 0.8rem;
  color: #aaa;
`

const ItemTitle = styled.div`
  margin-top: 1rem;
  line-height: 1.5;
  @media (max-width: 60rem){
    min-width: 0;
    margin-top: 0.5rem;
    font-size: 0.9rem;
  }
`

const ClippedItemTitle = styled(ItemTitle)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  @media (max-width: 60rem){
    overflow: visible;
    white-space: unset;
  }
`

type BlogItemDetailProps = {
  initial: string
  color: string
  date: Date
  title: string
  clip?: boolean
}
export const BlogItemDetail: FunctionComponent<BlogItemDetailProps> = ({initial, color, date, title, clip}) => {
  return <Outer>
    <Initial style={{color}}>{initial}</Initial>
    <DetailContainer>
      <ItemDate>{formatDate(date)}</ItemDate>
      {
        clip ?
        <ClippedItemTitle>{title}</ClippedItemTitle> :
        <ItemTitle>{title}</ItemTitle>
      }
      
    </DetailContainer>
  </Outer>
}